module.exports = __webpack_public_path__ + "img/hainan_logo.1cc9ec00.png";